var map = {
	"./box61.png": "25d0",
	"./box62.png": "f79b",
	"./box63.png": "cad4",
	"./box64.png": "ffb5",
	"./box65.png": "77dc",
	"./box66.png": "de93",
	"./box67.png": "1189",
	"./box68.png": "545a",
	"./box6Ft.png": "a558"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1157";